import { useMutation, gql } from "@apollo/client"
import { KNOWLEDGE_FIELDS } from "./useQueryKnowledges"

const CREATEKNOWLEDGE_MUTATION = gql`
  mutation CreateKnowledge($title: String!, $category: ID!, $groups: [ID!], $locations: [ID!], $content: [KnowledgeContentInput!]!) {
    createKnowledge(title: $title, category: $category, groups: $groups, locations: $locations, content: $content) {
      ${KNOWLEDGE_FIELDS}
    } 
  }
`

const useMutationCreateKnowledge = () => useMutation(CREATEKNOWLEDGE_MUTATION)

export { useMutationCreateKnowledge }
